<template>
  <div :id="paintAreaId" class="component-painter">
    <slot />
  </div>
</template>

<script>
import html2canvas from 'html2canvas'

export default {
  name: 'Painter',
  data() {
    return {
      paintAreaId: `paint-${Date.now()}${Math.floor(Math.random() * 1000)}`
    }
  },
  methods: {
    /**
     * 绘制对象，导出绘制内容
     */
    async draw() {
      // 导出画布
      const cvs = await html2canvas(
        document.querySelector(`#${this.paintAreaId}`),
        { useCORS: true }
      )
      return new Promise((resolve, reject) => {
        cvs.toBlob(blob => {
          // 返回处理结果
          resolve(new File([blob], `${Date.now()}.png`, { type: 'image/png' }))
        })
      })
    }
  }
}
</script>

<style lang="scss">
.component-painter {
  background-color: #ffffff;
  padding: 20px;
  img {
    width: 100%;
    height: auto;
    &.fixed-right {
      width: auto;
      height: 120px;
      margin: -120px 0 0 52%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Painter.vue